// Форматирование времени медиа: «м:ss» или «ч:мм:сс»
export const formatTime = (time) => {
	if (!time || !isFinite(time)) return '0:00';
	const seconds = Math.floor(time % 60);
	const minutes = Math.floor((time / 60) % 60);
	const hours = Math.floor(time / 3600);
	const pad = (num) => String(num).padStart(2, '0');
	if (hours > 0) {
		return `${hours}:${pad(minutes)}:${pad(seconds)}`;
	}
	return `${minutes}:${pad(seconds)}`;
};
